import { useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { adminEmailCode } from "../lib/api";

// Administrator-only alternative to the PIN: a 6-digit code emailed to the Administrator's address.
export const AdminEmailStep = ({ onBack, onSent }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await adminEmailCode(email.trim());
      onSent({ challenge_id: r.challenge_id, email_hint: r.email_hint, via: "email" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't send the code");
    } finally {
      setBusy(false);
    }
  };
  return (
    <motion.form onSubmit={go} initial={{ opacity: 0, x: 12 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 12 }} data-testid="admin-email-step" className="mt-6 text-left">
      <div className="flex items-center gap-2 text-sm font-medium"><ShieldCheck className="h-4 w-4 text-primary" /> Administrator sign-in</div>
      <p className="text-xs text-muted-foreground mt-1">Enter the Administrator's email and we'll send a 6-digit code. It works instead of the PIN.</p>
      <input data-testid="admin-email-input" type="email" autoFocus required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@example.com" className="mt-4 w-full h-11 rounded-xl border border-border bg-card px-3 text-sm" />
      <button data-testid="admin-email-send-btn" type="submit" disabled={busy || !email.includes("@")} className="mt-3 w-full h-11 rounded-full bg-primary text-primary-foreground text-sm font-medium disabled:opacity-50 inline-flex items-center justify-center gap-2">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} {busy ? "Sending…" : "Email me a code"}
      </button>
      <div className="mt-3 text-center"><button type="button" data-testid="admin-email-back-btn" onClick={onBack} className="text-xs text-muted-foreground hover:text-primary">← Back to PIN</button></div>
    </motion.form>
  );
};
